"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsBridgeEnabled = exports.getIsPricingEnabled = exports.fetchEolConfig = exports.hasMonetizationStopped = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_EOL_CONFIG = "SET_EOL_CONFIG";
var SET_IS_LOADING = "SET_IS_LOADING";

var initialState = {
  isLoading: true,
  eolConfig: null,
  hasFabLaunched: false,
  hasMonetizationStopped: null
};

var hasMonetizationStopped = exports.hasMonetizationStopped = false;

var fetchEolConfig = exports.fetchEolConfig = function fetchEolConfig() {
  return function (dispatch) {
    return _axios2.default.get(_config2.default.eolConfigUrl).then(function (_ref) {
      var data = _ref.data;

      dispatch({
        type: SET_EOL_CONFIG,
        payload: data
      });
    }).catch(function (error) {
      console.error("Failed to fetch EOL config file:", error);
      dispatch({
        type: SET_IS_LOADING,
        payload: false
      });
    });
  };
};

var DEFAULT_EOL_CONFIG = {
  common: {
    fabLaunchDate: "Tue, 01 Oct 2024 00:00:00 GMT",
    cutOffDate: "Wed, 30 Oct 2024 00:00:00 GMT",
    commsReleaseDate: "Mon, 23 Sep 2024 00:00:00 GMT",
    stopMonetizingDate: "Mon, 23 Sep 2024 00:00:00 GMT",
    fabURL: "https://fab.com",
    excludedLicensees: ["studio", "studio-lite", "custom"]
  },
  inAppBanner: {
    enabled: true,
    content: "Megascans are moving to Fab!",
    buttonText: "More Info",
    buttonLink: "https://quixel.com/blog/2024/09/17/fab-content-marketplace-launches-in-october-publishing-portal-opens-today"
  },
  fabLaunchPopup: {
    enabled: true,
    title: "A new home for Megascans",
    content: "Megascans have moved! Head to <a id='fab-link' href='https://fab.com' target='_blank'>fab.com</a> to find all the high-quality 3D assets that you have come to expect from Quixel.<br/><br/><a id='fab-link' href='https://quixel.com/megascans/home' target='_blank'>Quixel.com</a> and Bridge will still allow you access to previously acquired content and MetaHumans.",
    buttons: [{
      buttonText: "Stay here",
      buttonLink: "#CLOSE"
    }, {
      buttonText: "Visit Fab.com",
      buttonLink: "https://fab.com"
    }]
  },
  autoRenewDeactivatedPopup: {
    enabled: true,
    title: "Your Quixel subscription is now free",
    content: "As we prepare for the launch of Fab, a few things are changing.<br/><br/>Starting today, all Megascans are free on Bridge and <a href='https://quixel.com' target='_blank'>Quixel.com</a> under the Epic Content License.<br/><br/>We're also turning off auto-renew on your purchased subscription. You will not be charged again for your subscription.<br/><br/>When Fab launches, if you have a balance of eligible points on your Quixel account, you will be able to request that they be either converted to Epic Wallet credit or refunded to you.",
    maxSeenCount: 1
  },
  redirectToFab: {
    enabled: true,
    content: "This asset is now available on <a id='fab-link' href='https://fab.com' target='_blank'>FAB</a>."
  },
  pointsToCreditPopup: {
    enabled: true,
    title: "Action Required: Quixel Points",
    content: "Quixel points have been discontinued. You have a points balance ({{POINTS}}) that is eligible for conversion or refund. You will have until {{CUT_OFF_DATE}} to choose what you would like to do with your points.<br/><br/>Click below to get started.",
    buttons: [{
      buttonText: "Manage my points",
      buttonLink: "/convert-points"
    }]
  },
  website: {
    heroBanner: {
      title: "EXPLORE MEGASCANS ON FAB",
      videoFile: "fab-assets-logo-looped-webcompressed.mp4",
      buttonText: "Go to Fab",
      buttonUrl: "https://www.fab.com"
    },
    pricing: {
      isPricingEnabled: false,
      cutOffDate: "Fri, 29 Nov 2024 00:00:00 GMT"
    },
    isBridgeEnabled: true
  },
  claimAll: {
    cutOffDate: "Fri, 22 Nov 2024 00:00:00 GMT",
    inAppBanner: {
      enabled: true,
      content: "Claim all legacy Megascans in one click",
      buttonText: "Claim All",
      buttonLink: "https://fab.com"
    },
    fabLaunchPopup: {
      enabled: true,
      title: "Claim All Megascans",
      content: "Megascans have moved! Head to <a id='fab-link' href='https://fab.com' target='_blank'>fab.com</a> to find all the high-quality 3D assets that you have come to expect from Quixel.<br/><br/><a id='fab-link' href='https://quixel.com/megascans/home' target='_blank'>Quixel.com</a> and Bridge will still allow you access to previously acquired content and MetaHumans.",
      buttons: [{
        buttonText: "Stay here",
        buttonLink: "#CLOSE"
      }, {
        buttonText: "Claim All",
        buttonLink: "#CLAIM_ALL"
      }]
    }
  }
};

var eol = function eol() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_EOL_CONFIG:
      var eolConfig = action.payload;
      exports.hasMonetizationStopped = hasMonetizationStopped = !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.stopMonetizingDate));
      return (0, _extends3.default)({}, state, {
        eolConfig: process.env.NODE_ENV === "development" ? DEFAULT_EOL_CONFIG : eolConfig,
        isLoading: false,
        hasFabLaunched: !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.fabLaunchDate)),
        hasMonetizationStopped: hasMonetizationStopped
      });

    case SET_IS_LOADING:
      return (0, _extends3.default)({}, state, {
        isLoading: true
      });

    default:
      return state;
  }
};

var getIsPricingEnabled = exports.getIsPricingEnabled = function getIsPricingEnabled(eolConfig) {
  return eolConfig && eolConfig.hasOwnProperty("website") && eolConfig.website.hasOwnProperty("pricing") && eolConfig.website.pricing.hasOwnProperty("isPricingEnabled") && eolConfig.website.pricing.isPricingEnabled && !(0, _moment2.default)(new Date()).isAfter(eolConfig.website.pricing.cutOffDate);
};
var getIsBridgeEnabled = exports.getIsBridgeEnabled = function getIsBridgeEnabled(eolConfig) {
  return eolConfig && eolConfig.hasOwnProperty("website") && eolConfig.website.hasOwnProperty("isBridgeEnabled") && eolConfig.website.isBridgeEnabled;
};

exports.default = eol;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/eol.js
// module id = 183
// module chunks = 0